export const LocalStoreKeys = Object.freeze({
    profile : "profile",
    theme : "theme"
});